import { useState } from 'react';
import Breadcrumb from '../../../common/breadcrumb';
import DowntimeReportFilters from "./downtimeReportFilters";
import DowntimeReportBody from './downtimeReportBody';
import LoadingIndicator from "../../../common/loadingIndicator";

/**
 * Downtime report component
 * @returns {JSX.Element}
 * @constructor
 */

const DowntimeReport = () => {
    const [tableData, setTableData] = useState([]);
    const [reportFilters, setReportFilters] = useState({
        date: '',
        isLoading: false,
        isSubmitted: false,
    });

    return (
        <>
            <Breadcrumb title="Downtime Report" parent="Toolbox"/>
            <div className="s-downtime-report">
                <DowntimeReportFilters {...{tableData, setTableData, setReportFilters}} />
                <DowntimeReportBody {...{reportFilters, tableData}} />
            </div>
            <LoadingIndicator isLoading={reportFilters.isLoading}/>
        </>
  );
}

export default DowntimeReport;
